import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

export const addCustomProductLoanProposal = (getData: any) => {
	const data = {
		addCustomProductLoanIndexDataToken: getData,
	};
	const url = `${API_URL}AddCustomProductLoanIndexToken`;
	return makeApiCall(url, data);
};

export const updateCustomProductLoanProposal = (getData: any) => {
	const data = {
		updateCustomLoanIndexDataToken: getData,
	};
	const url = `${API_URL}UpdateCustomLoanIndexToken`;
	return makeApiCall(url, data);
};

export const customProductDetailsFetch = (fetchData: any) => {
	const data = {
		getCustomLoanIndexInfoDataToken: fetchData,
	};
	const url = `${API_URL}GetCustomLoanIndexInfoToken`;
	return makeApiCall(url, data);
};
